/**
  Idle = 0,
  Running = 1,
  Hold = 2,
  Alarm = 3
  Unknown = 4
 */

export function statusCssClass(status) {
  if (status === 0) {
    return 'primary'
  }
  if (status === 1) {
    return 'success'
  }
  if (status === 2) {
    return 'warning'
  }
  if (status === 3) {
    return 'danger'
  }
  if (status === 4) {
    return 'secondary'
  }
  return 'primary'
}

export function statusCssBackgroundClass(status) {
  if (status === 0) {
    return 'bg-primary'
  }
  if (status === 1) {
    return 'bg-success'
  }
  if (status === 2) {
    return 'bg-warning'
  }
  if (status === 3) {
    return 'bg-danger'
  }
  if (status === 4) {
    return 'bg-secondary'
  }
  return 'bg-primary'
}

export function statusCssTextClass(status) {
  if (status === 0) {
    return 'text-primary'
  }
  if (status === 1) {
    return 'text-success'
  }
  if (status === 2) {
    return 'text-warning'
  }
  if (status === 3) {
    return 'text-danger'
  }
  if (status === 4) {
    return 'text-secondary'
  }
  return 'text-primary'
}

export function statusCssCardAccentClass(status) {
  if (status === 0) {
    return 'card-accent-primary'
  }
  if (status === 1) {
    return 'card-accent-success'
  }
  if (status === 2) {
    return 'card-accent-warning'
  }
  if (status === 3) {
    return 'card-accent-danger'
  }
  if (status === 4) {
    return 'card-accent-secondary'
  }
  return 'card-accent-primary'
}

export function statusHistoryCssBackgroundClass(totalRunningMinutes) {
  if (totalRunningMinutes >= 0 && totalRunningMinutes <= 10) {
    return 'bg-danger'
  }
  if (totalRunningMinutes >= 10 && totalRunningMinutes <= 25) {
    return 'bg-danger'
  }
  if (totalRunningMinutes >= 25 && totalRunningMinutes <= 30) {
    return 'bg-warning'
  }
  if (totalRunningMinutes >= 30 && totalRunningMinutes <= 45) {
    return 'bg-success'
  }
  if (totalRunningMinutes >= 45 && totalRunningMinutes <= 100) {
    return 'bg-success'
  }
  return 'bg-primary'
}

export function insightsStatusColors(statusName) {
  if (
    statusName.toUpperCase() === 'RUNNING' ||
    statusName.toUpperCase() === 'ACTIVE' ||
    statusName.toUpperCase() === 'RAPID'
  ) {
    return '#2eb85c'
  }

  if (
    statusName.toUpperCase() === 'WAITING' ||
    statusName.toUpperCase() === 'FEEDHOLD' ||
    statusName.toUpperCase() === 'FEED HOLD'
  ) {
    return '#f9b115'
  }

  return '#321fdb'
}

export function insightsActivityColors(activityName) {
  if (activityName.toUpperCase() === 'PRODUCTION') {
    return '#2eb85c'
  }

  return '#321fdb'
}
